import React from 'react';
import { Link } from 'react-router-dom';
import appIcon from '../app-icon.png';
import AppStoreBadge from './AppStoreBadge';

function BrandBar() {
    return (
        <header className="brand-bar">
            <Link to="/" className="brand-bar-logo" aria-label="Demodeck">
                <img src={appIcon} alt="" className="brand-bar-icon" />
                <span className="brand-bar-wordmark">demodeck</span>
            </Link>
            <nav className="brand-bar-nav">
                <AppStoreBadge href="https://apps.apple.com/app/id1536248706" className="brand-bar-appstore" />
                <Link to="/login" className="brand-bar-cta">
                    Sign in
                </Link>
            </nav>
        </header>
    );
}

export default BrandBar;
